export default __webpack_public_path__ + "static/media/logo_rtg_white.c6569ca4.svg";